module.exports = __webpack_public_path__ + "dcf097bbb96f291f3a02517d1645cdf1.jpg";